import React, {useCallback, useEffect, useState} from "react";
import {ReportsDetail, BoardSearchResult} from "../../assets/GlobalStyles";
import {reportsMedia, reportsStaticsInventoryByMediaColumn, reportsStaticsMediaColumn} from "./entity/media";
import {modalController} from "../../store";
import {selectStaticsInventoryByMedia, selectStaticsMedia} from "../../services/reports/mediaAxios";
import TableDetail from "../../components/table/TableDetail";
import HorizontalScrollGuide from "../../components/table/HorizontalScrollGuide";
import PerformanceComparisonChart from "../../components/reports/PerformanceComparisonChart";
import {ReportsCondition} from "../../components/reports/Condition";
import {useAtomValue, useSetAtom} from "jotai";
import {sort} from "../../components/reports/sortList";
import {ReportsMediaModalComponent} from "../../components/reports/ModalComponents";
import {lockedRows, summaryReducer} from "./entity/common";
import {UserInfo} from "../layout";
import {
  CollapseIcon, ConditionBody, ConditionSummary, ExcelHeaderButton, HeaderRight,
  ReportCard, ReportPage, SectionAccent, SectionHeader, SectionHeading, SummaryChip, TableBody
} from "./ReportSharedLayout";

export function ReportsMediaModal(props){
  const setModal = useSetAtom(modalController)
  const handleClick = () => setModal({
    isShow: true,
    width: 1320,
    blur: true,
    modalComponent: () => <ReportsMediaModalComponent userId={props.userId} siteName={props.siteName}/>
  })
  return <ReportsDetail onClick={(e) => {e.stopPropagation(); handleClick()}}/>
}

export default function ReportsMedia(){
  const [searchCondition, setSearchCondition] = useState(reportsMedia)
  const [searchState, setSearchState] = useState(reportsMedia)
  const [, setLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [isConditionOpen, setIsConditionOpen] = useState(false)
  const [downloadTrigger, setDownloadTrigger] = useState(0)
  const [chartData, setChartData] = useState([])

  const userInfoState = useAtomValue(UserInfo)
  const fetchDetailData = useCallback(async (media) => {
    const condition = {...searchCondition, pageSize:30, currentPage:1, sortType:sort('INVENTORY_NAME_DESC',null)}
    const response = await selectStaticsInventoryByMedia(media?.userId, condition)
    return response?.content || []
  }, [searchCondition])

  useEffect(() => {
    const condition = {...searchCondition,pageSize:100,currentPage:1,sortType:"REVENUE_AMOUNT_DESC"}
    selectStaticsMedia(condition).then(response => {
      let data = response?.content || []
      if(userInfoState?.id !== '') data = data.filter(item => item.userId === userInfoState?.id)
      setChartData(data)
    })
  },[searchCondition,userInfoState])

  const dataSource = useCallback(async ({skip, sortInfo, limit}) => {
    const condition = {...searchCondition, pageSize:30, currentPage:skip/limit === 0 ? 1 : (skip/limit)+1, sortType:sort('SITE_NAME_DESC',sortInfo)}
    const response = await selectStaticsMedia(condition)
    let data = response?.content || []
    if(userInfoState?.id !== '') data = data.filter(d => d.userId === userInfoState?.id)
    setTotalCount(response?.totalElements || 0)
    return {data, count:response?.totalElements || 0}
  }, [searchCondition, userInfoState])

  const onSearch = () => setSearchCondition({...searchState})
  const toggleCondition = () => setIsConditionOpen(open => !open)

  return (
    <ReportPage>
      <ReportCard $condition>
        <SectionHeader $clickable $open={isConditionOpen} role="button" tabIndex={0}
          aria-expanded={isConditionOpen} onClick={toggleCondition}
          onKeyDown={e => {if(e.key === "Enter" || e.key === " "){e.preventDefault();toggleCondition()}}}>
          <SectionHeading><SectionAccent/><div><strong>조회 조건</strong><span>광고 상품, 디바이스와 기간을 기준으로 매체별 데이터를 조회합니다.</span></div></SectionHeading>
          <HeaderRight>
            {!isConditionOpen && <ConditionSummary>
              <SummaryChip>상품 <b>{searchCondition.productType || "전체"}</b></SummaryChip>
              <SummaryChip>디바이스 <b>{searchCondition.deviceType || "전체"}</b></SummaryChip>
              <SummaryChip>기간 <b>{searchCondition.searchStartDate} ~ {searchCondition.searchEndDate}</b></SummaryChip>
            </ConditionSummary>}
            <CollapseIcon $open={isConditionOpen}/>
          </HeaderRight>
        </SectionHeader>
        {isConditionOpen && <ConditionBody onClick={e => e.stopPropagation()}>
          <ReportsCondition modern searchState={searchState} setSearchState={setSearchState} onSearch={onSearch}/>
        </ConditionBody>}
      </ReportCard>

      <ReportCard>
        <PerformanceComparisonChart data={chartData} nameKey="siteName"
          title="매체별 주요 성과"
          description="수익금 기준 상위 5개 매체의 노출수와 수익금을 비교합니다."/>
      </ReportCard>

      <ReportCard>
        <SectionHeader>
          <SectionHeading><SectionAccent/><div><strong>매체별 데이터</strong><span>조회 조건에 해당하는 매체 성과를 확인하고 행을 펼쳐 지면별 상세 데이터를 확인합니다.</span></div></SectionHeading>
          <ExcelHeaderButton type="button" onClick={() => setDownloadTrigger(v => v + 1)}>엑셀 저장</ExcelHeaderButton>
        </SectionHeader>
        <TableBody>
          <HorizontalScrollGuide/>
          <BoardSearchResult>
            <TableDetail columns={reportsStaticsMediaColumn} lockedRows={lockedRows} summaryReducer={summaryReducer}
              data={dataSource} detailData={fetchDetailData} detailColumn={reportsStaticsInventoryByMediaColumn}
              idProperty="userId" defaultSortInfo={{name:"siteName",dir:-1}} onLoadingChange={setLoading}
              totalCount={[totalCount,'보고서']} downloadList externalDownload downloadTrigger={downloadTrigger}
              fileName="매체별_보고서" pagination livePagination scrollThreshold={0.7}
              headerHeight={44} style={{minHeight:500}}/>
          </BoardSearchResult>
        </TableBody>
      </ReportCard>
    </ReportPage>
  )
}
